<template>
  <div class="light" :class="{ disabled: isBuildingGIF }">
    <div class="control-panel">
      <div class="left">
        <a-radio-group
          :value="lightIndex"
          size="large"
          @change="onLightIndexSelect"
          v-visible="!isPlaying"
        >
          <a-radio-button :value="5"> {{ $t("light.name") }} 1 </a-radio-button>
          <a-radio-button :value="6"> {{ $t("light.name") }} 2 </a-radio-button>
          <a-radio-button :value="7"> {{ $t("light.name") }} 3 </a-radio-button>
        </a-radio-group>
      </div>
      <i
        v-if="isPlaying"
        class="paly iconfont iconstop-o"
        @click="isPlaying = !isPlaying"
      />
      <i
        v-else
        class="stop iconfont iconplay-o"
        @click="isPlaying = !isPlaying"
      />
      <div class="right">
        <div class="speed">
          <i class="iconfont iconlightning" />
          {{ $t("slow") }}
          <a-slider
            class="slider"
            v-model="speed"
            :min="12"
            :max="16"
            :tip-formatter="(value) => value - 10"
            :tooltipVisible="false"
          />
          {{ $t("fast") }}
        </div>
      </div>
    </div>
    <div class="light-panel">
      <div class="remove">
        <div class="remove-hover">
          <i
            class="close iconfont iconclose"
            v-if="frameLength > 1 && !isPlaying"
            @click="removeFrame"
          />
          <i
            class="reset iconfont iconreset"
            v-if="frameLength > 1 && !isPlaying"
            @click="removeAllFrame"
          />
          <i
            class="iconfont iconminus-o"
            v-visible="frameLength > 1 && !isPlaying"
          />
        </div>
      </div>
      <c-led-pcb-65-fluffy
        class="lights"
        :isPlaying="isPlaying"
        :speed="speed"
        :frames="frames"
        :frameIndex="frameIndex"
        @led-click="onLEDClick"
      />
      <div class="add" v-show="frameLength < 100 && !isPlaying">
        <i class="iconfont iconplus-o" @click="addFrame" />
        <span>
          {{ $t("light.add") }}
        </span>
      </div>
    </div>
    <div class="page-panel" v-visible="frameLength > 1 && !isPlaying">
      <i
        class="prev iconfont iconleft"
        v-visible="frameNow > 1 && !isPlaying"
        @click="prevFrame"
      />
      <div class="page">
        01
      </div>
      <a-slider
        class="page-slider"
        :value="frameNow"
        @change="changeFrame"
        :min="1"
        :max="frameLength"
        :tipFormatter="null"
      />
      <div class="page-now">
        {{ frameNow }}
      </div>
      <div class="page">
        {{ frameLength }}
      </div>
      <i
        class="next iconfont iconright"
        v-visible="frameNow < frameLength && !isPlaying"
        @click="nextFrame"
      />
    </div>
    <div class="action-panel">
      <c-pcb-converter-65-fluffy
        @change="onConversionChange"
        v-visible="!isPlaying"
      >
        <div class="upload" @click="colorPickerVivisble = false">
          <i class="iconfont icontupian" />
          {{ $t("light.imageConverter") }}
        </div>
      </c-pcb-converter-65-fluffy>
      <c-undo
        @undo="setFrames"
        :data="frames"
        v-visible="!isPlaying"
        :key="'undo' + lightIndex"
      >
        <div class="undo">
          <i class="iconfont iconchehui" />
          {{ $t("undo") }}
        </div>
      </c-undo>
    </div>
    <div class="color-panel">
      <div class="slider-panel">
        <c-slider class="slider" :value="color" @input="onColorInput" />
        <c-color-picker v-model="color" :presetColor="presetColor" />
      </div>
      <div class="hex-color">
        HEX COLOR
        <span>#</span
        ><input type="text" :value="inputColor" @change="onColorInput" />
      </div>
    </div>
    <div class="buttons">
      <div class="button" @click="onBack">
        {{ $t("confirm") }} & {{ $t("back") }}
      </div>
    </div>
    <div class="keyboard" @click="goKeyboard">
      <i class="iconfont iconarrow-right" />
      <div v-html="$t('index.keyboardTitle')"></div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { speedList } from "@/utils";

export default {
  name: "InSwitchLED",
  data() {
    return {
      lightIndex: 5,
      isPlaying: false,
      speed: 1,
      frames: [],
      frameIndex: 0,
      color: "#8028f5",
      presetColor: "#8028f5",
      colorPickerVivisble: false,
      saved: true,
      isBuildingGIF: false,
    };
  },
  computed: {
    ...mapState("assets", {
      images: "images",
    }),
    ...mapState(["profile65Fluffy"]),
    frameNow() {
      return this.frameIndex + 1;
    },
    frameLength() {
      return this.frames.length;
    },
    inputColor() {
      return this.color.replace("#", "");
    },
  },
  methods: {
    initLight() {
      this.frames = this.profile65Fluffy.data.page_data[
        this.lightIndex
      ].keyframes.frame_data;
      this.speed =
        speedList.findIndex(
          (speed) =>
            speed ===
            this.profile65Fluffy.data.page_data[this.lightIndex].speed_ms
        ) + 1 || 12;
    },
    onLEDClick({ index }) {
      let newFrames = [...this.frames];
      newFrames[this.frameIndex].frame_RGB[index] = this.color;
      this.setFrames(newFrames);
      this.presetColor = this.color;
    },
    onLightIndexSelect(e) {
      this.onSave();
      this.lightIndex = e.target.value;
      this.initLight();
    },
    removeFrame() {
      let newFrames = [...this.frames];
      newFrames.splice(this.frameIndex, 1);
      this.frameIndex = this.frameIndex > 1 ? this.frameIndex - 1 : 0;
      this.setFrames(newFrames);
    },
    removeAllFrame() {
      this.$confirm({
        title: this.$t("light.removeAllConfirm", [this.frameLength - 1]),
        onOk: () => {
          let newFrames = [this.frames[this.frameIndex]];
          this.frameIndex = 0;
          this.setFrames(newFrames);
        },
        width: "8.4rem",
        okText: this.$t("yes"),
        cancelText: this.$t("cancel"),
        centered: true,
      });
    },
    addFrame() {
      let newFrames = [...this.frames];
      let frame_RGB = [...newFrames[this.frameIndex].frame_RGB];
      newFrames.splice(this.frameIndex, 0, { frame_RGB });
      this.frameIndex = this.frameIndex + 1;
      this.setFrames(newFrames);
      this.$message.info(this.$t("light.addSuccess"));
    },
    changeFrame(page) {
      this.frameIndex = page - 1;
    },
    nextFrame() {
      this.frameIndex = this.frameIndex + 1;
    },
    prevFrame() {
      this.frameIndex = this.frameIndex - 1;
    },
    onConversionChange({ RGB, frames }) {
      if (frames) {
        this.setFrames(frames.splice(0, 100));
      } else {
        let newFrames = [...this.frames];
        newFrames.splice(this.frameIndex, 1, { frame_RGB: RGB });
        this.setFrames(newFrames);
      }
      this.onSave();
    },
    onColorInput(e) {
      const color = e.hex ? e.hex : "#" + e.target.value;
      this.color = color.length === 7 ? color : "#000000";
    },
    setFrames(frames) {
      this.frames = frames;
      this.saved = false;
    },
    onBack() {
      this.onSave();
      this.$router.push(this.$paths.keyboard65Fluffy);
    },
    onSave() {
      this.profile65Fluffy.data.page_data[this.lightIndex].keyframes = {
        frame_data: this.frames.map((item, index) => ({
          ...item,
          frame_index: index,
        })),
        frame_num: this.frames.length,
        valid: true,
      };
      this.profile65Fluffy.data.page_data[this.lightIndex].speed_ms =
        speedList[this.speed - 1] || 90;
      this.saved = true;
      return this.$store.dispatch("profile65Fluffy/setData", {
        ...this.profile65Fluffy.data,
      });
    },
    goKeyboard() {
      this.onSave();
      this.$router.push(this.$paths.keyboard65Fluffy);
    },
  },
  mounted() {
    this.initLight();
  },
};
</script>

<style lang="scss" scoped>
.light {
  min-height: inherit;
  color: #ffffff;
  padding: 50px 0 130px 0;

  &.disabled {
    user-select: none;
    pointer-events: none;
    cursor: not-allowed;
  }

  .title {
    font-size: 20px;
    text-align: center;
    margin-bottom: 40px;
  }

  .control-panel {
    @include flex-center;
    width: 930px;
    margin: 0 auto 25px auto;
    z-index: 1;
    position: relative;

    .left,
    .right {
      width: 50%;
      flex: auto;
    }

    .right {
      display: flex;
      justify-content: flex-end;
    }

    .paly,
    .stop {
      @include icon-hover;
      font-size: 64px;
    }

    .brightness,
    .speed {
      @include flex-center;
      font-size: 12px;
      flex: none;

      .iconfont {
        font-size: 26px;
        line-height: 1;
        color: #ffffff;
        margin-right: 0.2rem;
      }

      .slider {
        width: 150px;
        margin-left: 20px;
        margin-right: 30px;
      }
    }

    .speed {
      .iconfont {
        font-size: 22px;
      }
    }
  }

  .light-panel {
    @include flex-center;
    margin-bottom: 20px;
    position: relative;

    .remove,
    .add {
      flex: auto;
      @include flex-center;
      position: absolute;
      top: 40%;
      z-index: 1;

      i {
        font-size: 36px;
        color: $primary-color;
        background: #171717;
        border-radius: 50%;
        overflow: hidden;
        position: relative;
        cursor: pointer;
      }

      span {
        font-size: 12px;
        padding: 0 10px;
        color: #ffffff;
        visibility: hidden;
        display: none;
      }

      &:hover span {
        visibility: visible;
      }
    }

    .remove {
      justify-content: flex-end;
      right: 50%;
      margin-right: 700px;

      .remove-hover {
        position: relative;
        @include flex-center;

        .close,
        .reset {
          width: 36px;
          height: 36px;
          @include flex-center;
          color: #ffffff;
          background: $primary-color;
          font-size: 22px;
          position: absolute;
          transform: scale(0.3);
          opacity: 0.3;
          transition: all 0.5s ease-in-out;
          transition-delay: 0.2s;
        }

        .reset {
          transition-delay: 0.4s;
          font-size: 24px;
        }

        .close {
          margin-top: -80px;
          transform: scale(1);
          opacity: 1;
          transition-delay: 0s;
        }

        .reset {
          margin-top: 80px;
          transform: scale(1);
          opacity: 1;
          transition-delay: 0.15s;
        }

        .iconminus-o {
          display: none;
        }
      }
    }

    .add {
      justify-content: flex-start;
      left: 50%;
      margin-left: 700px;

      i {
        @include icon-hover;
        flex: none;
      }
    }

    .lights {
      width: 1600px;
      height: 625px;
      margin-top: -170px;
      z-index: 0;
    }
  }

  .page-panel {
    @include flex-center;
    position: relative;
    margin-bottom: 40px;

    .page-slider {
      width: 180px;
    }

    .prev,
    .next {
      @include icon-hover;
      font-size: 36px;
      padding: 5px 10px;
      margin: 0 50px;
    }

    .page {
      width: 60px;
      text-align: center;
    }

    .page-now {
      width: 50px;
      text-align: center;
      position: absolute;
      left: 50%;
      margin-left: -25px;
      bottom: -15px;
      font-size: 12px;
    }
  }

  .action-panel {
    @include flex-center;
    margin-bottom: 30px;

    .rotation,
    .upload,
    .undo {
      @include flex-center;
      width: auto;
      height: 40px;
      padding: 0 20px;
      margin-left: 30px;
      font-size: 14px;
      color: $primary-color;
      border: 1px solid $primary-color;
      border-radius: 10px;
      cursor: pointer;

      i {
        font-size: 26px;
        margin-right: 10px;
      }
    }

    .upload {
      margin-left: 0px;

      i {
        font-size: 24px;
      }
    }
  }

  .color-panel {
    @include flex-center;
    flex-direction: column;
    margin-bottom: 50px;

    .slider-panel {
      @include flex-center;
      margin-bottom: 30px;
      position: relative;

      .slider {
        width: 600px;
        margin: 0 30px;
      }

      .color {
        position: absolute;
        right: -20px;
        width: 46px;
        height: 46px;
        border-radius: 50%;
        border: 1px solid $primary-color;
        transform: translateX(50%);
        transition: all 0.1s;
        cursor: pointer;

        &:hover {
          width: 50px;
          height: 50px;
        }
      }
    }

    .hex-color {
      font-size: 20px;

      span {
        color: $primary-color;
        margin: 0 5px 0 30px;
      }

      input {
        width: 110px;
        text-align: center;
        color: $primary-color;
        user-select: text;
        border: 1px solid $primary-color;
      }
    }
  }

  .buttons {
    @include flex-center;

    .button {
      @include button;
      width: 200px;
      margin: 0 100px;

      span {
        font-size: 24px;
        line-height: 12px;
      }
    }
  }

  .keyboard {
    @include flex-center;
    position: fixed;
    right: 50px;
    bottom: 200px;
    font-size: 20px;
    cursor: pointer;

    &:hover {
      color: $primary-color;
    }

    i {
      width: 54px;
      height: 54px;
      line-height: 54px;
      display: block;
      background: $primary-color;
      color: #ffffff;
      border-radius: 10px;
      margin-right: 20px;
      font-size: 22px;
      padding-left: 5px;
      text-align: center;
    }
  }
}
</style>

<style lang="scss">
.page-slider {
  padding: 3px 0;

  .ant-slider-rail {
    height: 4px;
    background: #ffffff !important;
  }
  .ant-slider-track {
    height: 4px;
  }

  .ant-slider-handle {
    margin-top: -5px;
  }
  .ant-slider-handle:focus,
  .ant-slider-handle:hover {
    margin-top: -6px;
  }
}
</style>
